import { apiRequest } from '../apiRequest';
import type { Organisation, OrganisationStats } from '../../../types/api/organisations';

type OrgListResponse = { organisations?: Organisation[] };
type OrgGetResponse = { organisation?: Organisation };
type OrgStatsResponse = OrganisationStats;

export const organisationsCoreAPI = {
  list: async (): Promise<Organisation[]> => {
    const data = await apiRequest<OrgListResponse>('/api/organisations', { method: 'GET' });
    return data.organisations ?? [];
  },
  get: async (orgId: string): Promise<Organisation> => {
    const data = await apiRequest<OrgGetResponse | Organisation>(
      `/api/organisations/${orgId}`,
      { method: 'GET' },
    );
    return ('organisation' in data && data.organisation ? data.organisation : data) as Organisation;
  },
  update: async (orgId: string, body: Record<string, unknown>): Promise<Organisation> => {
    const data = await apiRequest<OrgGetResponse | Organisation>(
      `/api/organisations/${orgId}`,
      {
        method: 'PATCH',
        body: JSON.stringify(body),
      },
    );
    return ('organisation' in data && data.organisation ? data.organisation : data) as Organisation;
  },
  regenerateGithubWebhookSecret: async (orgId: string) => {
    return await apiRequest<Record<string, unknown>>(
      `/api/organisations/${orgId}/github-webhook/regenerate-secret`,
      {
        method: 'POST',
        body: JSON.stringify({}),
      },
    );
  },
  getStats: async (orgId: string): Promise<OrganisationStats> => {
    const data = await apiRequest<OrgStatsResponse>(
      `/api/organisations/${orgId}/stats`,
      { method: 'GET' },
    );
    return {
      streamCount: data.streamCount ?? 0,
      projectCount: data.projectCount ?? 0,
      memberCount: data.memberCount ?? 0,
      repositoryCount: data.repositoryCount ?? 0,
    };
  },
};
